import React,{ useState } from 'react'
import './home.css'
import Header from '../components/Header'
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const Home = () => {
    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
      );
  return (
    <div className='home'>
        <Header />
      <Editor
        editorState={editorState}
        onEditorStateChange={setEditorState}
      />
    </div>
  )
}

export default Home